
import environment from '@/helpers/Environment'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class extends Vue {
  get homeLinkAttributes(): {
    is: string
    [key: string]: string
  } {
    const externalUrl = environment.sellerMeta?.logo_external_url ?? environment.web.external_urls?.logo
    if (externalUrl) {
      return { is: 'a', href: externalUrl }
    } else {
      return { is: 'router-link', to: '/' }
    }
  }
}
